export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const GAMES_API_URL = process.env.REACT_APP_GAMES_API_URL || 'http://localhost:5001';
// Revisado: 2025-12-18 [I18n Scan]
